import {
  type Form,
  type FormField,
  type FieldsField,
} from '@wix/ambassador-forms-v4-form/types';

import { type Submission } from '../submission';

export function mapByTargets(submission: Submission, form: Form): Submission {
  return mapBy(submission, form, 'target');
}

export function mapByIds(submission: Submission, form: Form): Submission {
  return mapBy(submission, form, 'id');
}

function mapBy(
  submission: Submission,
  form: Form,
  by: 'id' | 'target',
): Submission {
  const from = by === 'id' ? 'target' : 'id';
  const fields =
    (form?.fields?.length ?? 0) > 0
      ? form?.fields ?? []
      : form?.formFields ?? [];
  const getIdOrTarget = (
    field: FormField | FieldsField,
    _by: 'id' | 'target',
  ): string | null | undefined => {
    if (_by === 'id') {
      return field[_by];
    } else if ('inputOptions' in field) {
      return (field as FieldsField).inputOptions?.target;
    } else {
      return (field as FormField).target;
    }
  };
  return fields.reduce<Submission>(
    (acc, field) => {
      const source = getIdOrTarget(field, from);
      const destination = getIdOrTarget(field, by);
      if (
        source &&
        destination &&
        source !== destination &&
        acc.hasOwnProperty(source)
      ) {
        acc[destination] = acc[source];
        const { [source]: omitted, ...rest } = acc;
        acc = rest;
      }
      return acc;
    },
    { ...submission },
  );
}
